import { create } from "zustand";
import type { BlockMapEntry } from "@juro/shared";

type PreviewStore = {
  blobUrl: string | null;
  isGenerating: boolean;
  error: string | null;
  currentPage: number;
  totalPages: number;
  blockMap: BlockMapEntry[];
  hoveredBlockId: string | null;
  setBlobUrl: (url: string | null) => void;
  setGenerating: (value: boolean) => void;
  setError: (message: string | null) => void;
  setBlockMap: (entries: BlockMapEntry[]) => void;
  setHoveredBlockId: (id: string | null) => void;
  setPage: (page: number) => void;
  clearPreview: () => void;
};

export const usePreviewStore = create<PreviewStore>((set, get) => ({
  blobUrl: null,
  isGenerating: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  blockMap: [],
  hoveredBlockId: null,

  setBlobUrl: (url) => {
    const previous = get().blobUrl;
    if (previous && previous !== url) URL.revokeObjectURL(previous);
    set({ blobUrl: url });
  },
  setGenerating: (value) => set({ isGenerating: value }),
  setError: (message) => set({ error: message }),
  setBlockMap: (entries) => set({ blockMap: entries }),
  setHoveredBlockId: (id) => set({ hoveredBlockId: id }),
  setPage: (page) => set({ currentPage: page }),
  clearPreview: () => {
    const previous = get().blobUrl;
    if (previous) URL.revokeObjectURL(previous);
    set({ blobUrl: null, error: null, blockMap: [], hoveredBlockId: null, isGenerating: false });
  },
}));
